@if (hasAccess === false) {
  <form class="mat-elevation-z3">
    <mat-form-field>
      <mat-label>{{'CONFIGURATOR|Hasło' | translate}}</mat-label>
      <input matInput type="password" name="price-details-password" [(ngModel)]="password" required>
      @if (incorrectPassword) {
        <mat-error>{{ 'CONFIGURATOR|Podane hasło jest nieprawidłowe' | translate }}</mat-error>
      }
    </mat-form-field>
    <button mat-raised-button color="primary" (click)="checkAccess()">{{'CONFIGURATOR|Sprawdź' | translate}}</button>
  </form>
}
@if (hasAccess === true) {
  @if (!hiddenPrice && !beforePromotions) {
    <h3>{{conf.Price | currency : currency}}</h3>
  }
  @if (!hiddenPrice && beforePromotions) {
    <h3>{{conf.PriceBeforePromotions | currency : currency}}</h3>
  }
  <mat-accordion class="price-details-align">
    @for (seg of segments; track seg) {
      <mat-expansion-panel>
        <mat-expansion-panel-header [collapsedHeight]="'92px'" [expandedHeight]="'92px'">
          <mat-panel-title>
            <span>{{seg.id}}. {{seg.type}}</span>
            <b>
              @if (seg.name) {
                <span>{{seg.name}}</span>
              }
              @if (!seg.name) {
                <span>{{seg.type}}</span>
              }
            </b>
          </mat-panel-title>
          <mat-panel-description>
            <span></span>
            <span>
              @if (seg.valueType == 'value' && !hiddenPrice) {
                <h4 style="padding-right: 0px">{{seg.value | currency:currency:'—' }}</h4>
              }
              @if (seg.valueType == 'percent' && !hiddenPrice) {
                <h4 style="padding-right: 0px">{{percentConvert(seg.value)}}%</h4>
              }
              @if (seg.valueType == 'multiplier' && !hiddenPrice) {
                <h4 style="padding-right: 0px">{{seg.value}}</h4>
              }
            </span>
            <span>
              @if (seg.valueType == 'value' && !hiddenPrice) {
                <h4 style="font-weight: 400; padding-right: 0px">{{seg.baseValue | currency:currency:'—' }}</h4>
              }
              @if (seg.valueType == 'percent' && !hiddenPrice) {
                <h4 style="font-weight: 400; padding-right: 0px">{{percentConvert(seg.baseValue)}}%</h4>
              }
              @if (seg.valueType == 'multiplier' && !hiddenPrice) {
                <h4 style="font-weight: 400; padding-right: 0px">{{seg.baseValue}}</h4>
              }
            </span>
          </mat-panel-description>
        </mat-expansion-panel-header>
        @if (seg.to && seg.valueType == 'percent') {
          <div class="summaryStep">
            {{ 'CONFIGURATOR|Dopłata do:' | translate }}
            @if (!isArray(seg.to)) {
              <strong>{{seg.to}}</strong>
            }
            @if (isArray(seg.to)) {
              <strong>@for (item of seg.to; track item) {
                <span>{{item}}@if (!$last) {
                  <span>, </span>
                }</span>
              }</strong>
            }
            <br />
          </div>
        }
        <ng-container *ngTemplateOutlet="segmentDetails;context:{'data': seg.data}"></ng-container>
      </mat-expansion-panel>
    }
  </mat-accordion>
  <h2>{{'CONFIGURATOR|Wyliczone dopłaty' | translate}}</h2>
  <mat-accordion class="price-details-align">
    @for (seg of parts; track seg) {
      <mat-expansion-panel>
        <mat-expansion-panel-header  [collapsedHeight]="'92px'" [expandedHeight]="'92px'">
          <mat-panel-title>
            <span>{{seg.type}}</span>
            <b>
              @if (seg.name) {
                <span>{{seg.name}}</span>
              }
              @if (!seg.name) {
                <span>{{seg.type}}</span>
              }
            </b>
          </mat-panel-title>
          <mat-panel-description>
            <span></span>
            <span>
              @if (!hiddenPrice) {
                <h4 style="padding-right: 0px">{{seg.value | currency:currency:'—' }}</h4>
              }
            </span>
            <span>
              @if (seg.basePercent && !hiddenPrice) {
                <h4 style="font-weight: 400; padding-right: 0px">{{seg.basePercent}}</h4>
              }
              @if (!seg.basePercent && !hiddenPrice) {
                <h4 style="font-weight: 400; padding-right: 0px"></h4>
              }
            </span>
            <span>
              @if (!hiddenPrice) {
                <h4 style="font-weight: 400; padding-right: 0px">{{seg.baseValue | currency:currency:'—' }}</h4>
              }
            </span>
          </mat-panel-description>
        </mat-expansion-panel-header>
        <ng-container *ngTemplateOutlet="segmentDetails;context:{'data': seg.valueData}"></ng-container>
        <ng-container *ngTemplateOutlet="segmentDetails;context:{'data': seg.percentData}"></ng-container>
      </mat-expansion-panel>
    }
  </mat-accordion>
}

<ng-template #segmentDetails let-data="data">
  @if (!isArray(data) && isObject(data)) {
    <div class="summaryStep">
      @for (detail of data | keyvalue; track detail) {
        <div >
          {{detail.key}}:
          @if (!isArray(detail.value) && !isObject(detail.value) && detail.key != 'Cena' && detail.key != 'Grupy rabatów') {
            <strong>{{detail.value}}</strong>
          }
          @if (!hiddenPrice && !isArray(detail.value) && !isObject(detail.value) && detail.key == 'Cena' || detail.key == 'Grupy rabatów') {
            <strong>{{detail.value| currency:currency}}</strong>
          }
          <br />
          @if (isObject(detail.value) || isArray(detail.value)) {
            <span>
              @for (A of detail.value | keyvalue; track A) {
                <span>
                  @if ((!isArray(A.value) && !isObject(A.value)) && A.key != 'Id') {
                    <span>
                      &nbsp;&nbsp;&nbsp;&nbsp;{{A.key}}: <strong>{{A.value}}</strong><br />
                    </span>
                  }
                  @if (isObject(A.value) || isArray(A.value)) {
                    <span>
                      &nbsp;&nbsp;&nbsp;&nbsp;{{A.key}}:<br />
                      @for (B of A.value | keyvalue; track B) {
                        <span>
                          @if ((!isArray(B.value) && !isObject(B.value)) && B.key != 'Id cennika' && B.key != 'Id profilu') {
                            <span>
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{B.key}}: <strong>{{B.value}}</strong><br />
                            </span>
                          }
                          @if (isObject(B.value) || isArray(B.value)) {
                            <span>
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{B.key}}:<br />
                              @for (C of B.value | keyvalue; track C) {
                                <span>
                                  @if ((!isArray(C.value) && !isObject(C.value)) && C.key != 'Id') {
                                    <span>
                                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{C.key}}: <strong>{{C.value}}</strong><br />
                                    </span>
                                  }
                                  @if ((isObject(C.value) || isArray(C.value)) && C.key != 'systems') {
                                    <span><!-- ukryj "systems" -->
                                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{C.key}}:<br />
                                      @for (D of C.value | keyvalue; track D) {
                                        <span>
                                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{D.key}}: <strong>{{D.value}}</strong><br />
                                        </span>
                                      }
                                    </span>
                                  }
                                </span>
                              }
                            </span>
                          }
                        </span>
                      }
                    </span>
                  }
                </span>
              }
            </span>
          }
        </div>
      }
    </div>
  }
  @if (isArray(data)) {
    <div class="summaryStep">
      @for (item of data; track item) {
        <div >
          @for (detail of item | keyvalue; track detail) {
            <span>
              {{detail.key}}:
              @if (!isArray(detail.value) && !isObject(detail.value) && detail.key != 'Cena') {
                <strong>{{detail.value}}</strong>
              }
              @if (!hiddenPrice && !isArray(detail.value) && !isObject(detail.value) && detail.key == 'Cena') {
                <strong>{{detail.value| currency:currency}}</strong>
              }
              @if (isObject(detail.value) || isArray(detail.value)) {
                <span>
                  @for (A of detail.value | keyvalue; track A) {
                    <span>
                      @if (isObject(A.value) || isArray(A.value)) {
                        <span>
                          <br />{{A.key}}:
                          @for (B of A.value | keyvalue; track B) {
                            <span>
                              @if (isObject(B.value) || isArray(B.value)) {
                                <span>
                                  &nbsp;&nbsp;&nbsp;&nbsp;<br />{{B.key}}:
                                  @for (C of B.value | keyvalue; track C) {
                                    <span>
                                      @if (isObject(C.value) || isArray(C.value)) {
                                        <span>
                                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<br />{{C.key}}:
                                          @for (D of C.value | keyvalue; track D) {
                                            <span>
                                              <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{D.key}}: <strong>{{D.value}}</strong>
                                            </span>
                                          }
                                        </span>
                                      }
                                      @if (!isObject(C.value) && !isArray(C.value)) {
                                        <span>
                                          <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{C.key}}: <strong>{{C.value}}</strong>
                                        </span>
                                      }
                                    </span>
                                  }
                                </span>
                              }
                              @if (!isObject(B.value) && !isArray(B.value)) {
                                <span>
                                  <br />&nbsp;&nbsp;&nbsp;&nbsp;{{B.key}}: <strong>{{B.value}}</strong>
                                </span>
                              }
                            </span>
                          }
                        </span>
                      }
                      @if (!isObject(A.value) && !isArray(A.value)) {
                        <span>
                          {{A.key}}: <strong>{{A.value}}</strong><br />
                        </span>
                      }
                    </span>
                  }
                </span>
              }
              <br />
            </span>
          }
        </div>
      }
    </div>
  }
  @if (!isArray(data) && !isObject(data)) {
    <div class="summaryStep" >
    </div>
  }
</ng-template>
